module.exports = __webpack_public_path__ + "154ccd182313c345d3b9dd8571931eb5.wasm";